import { getCompany as retrieveCompany } from "api/public/company";

import findById from "utils/findById";

export const getCompany = (id) => (dispatch) =>
  dispatch({
    type: "COMPANY_PUBLIC_GET",
    payload: retrieveCompany(id),
  });

export const getCompanyForTooltip = (companyId) => (dispatch, getState) => {
  if (findById(getState().companies, companyId)) return null;

  return dispatch({
    type: "COMPANY_FOR_TOOLTIP_PUBLIC_GET",
    payload: retrieveCompany(companyId),
  });
};

export default getCompany;
